import type { Transition } from "motion/react";

/** Пружины из motion-спеки (кадры 62 / 62b) */
export const spring = {
  /** кнопки, чипы, прилипание к сетке */
  snappy: { type: "spring", stiffness: 500, damping: 35 } satisfies Transition,
  /** карточка ↔ модалка, поповеры */
  smooth: { type: "spring", stiffness: 380, damping: 32 } satisfies Transition,
  /** перелёт между колонками */
  gentle: { type: "spring", stiffness: 260, damping: 28 } satisfies Transition,
};

export const easeOut = [0.22, 1, 0.36, 1] as const;

export const fade: Transition = { duration: 0.2, ease: easeOut };
